import React from 'react'
import L from 'leaflet'
import insidePolygon from 'point-in-polygon'
import {Map, Marker, TileLayer} from 'react-leaflet'
import 'rc-slider/assets/index.css'
import {withRouter} from "react-router-dom";
import * as async from 'async';

/*** REDUX ACTIONS ****/
import {connect} from 'react-redux'
import {bindActionCreators} from 'redux'
import * as SensorsActions from '../../actions/sensors'
import * as PollutionAreasActions from '../../actions/pollutionAreas'
import * as AppActions from '../../actions/app'
import * as AnalyticsActions from '../../actions/analytics'

/*** COMPONENTS ***/
import {Polygon, AQIMarker, DummyCollection, HeatMap} from './MapComponents';
import {PopupNotification, BettAppBar, GradientPanel} from './BettAppBar';
import PolygonPanel from "./AdminAppBar";
import {ZoomController, Loading} from './Common';
import {getLatLon} from "../../actions/sensors";

import '../../index.css'
import './Map.css';


import {SensorLocation, SensorPoint, PolygonPoint} from "../../classes/index"

class MapBox extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            /** MAP VARS **/
            lat: 41.398058914378,
            lng: 2.14113235473,
            defaultZoom: 7,
            currentZoom: 13,
            currentMap: null,
            newMap: null,
            stationMap: props.match.path === "/stations/map/:station",
            stations: []
        };

        this.leafletMap = null;

        this.setMap = element => {
            if (element)
                this.leafletMap = element.leafletElement;
        };

        this.handleClick = this.handleClick.bind(this);
        this.closePolygon = this.closePolygon.bind(this);
        this.createSensor = this.createSensor.bind(this);
        this.handleAQIPoint = this.handleAQIPoint.bind(this);
    }

    /**
     * ----------------
     */

    componentDidMount() {

        let h = 12;
        let admin = false;

        // this.props.appActions.setAdmin(admin);
        /**----------**/

        if (this.state.stationMap) {
            let newArray = this.state.stations;
            let lat = 0;
            let lng = 0;
            let num = 0;

            async.each(this.props.match.params.station.split(','), (station, cb) => {
                getLatLon(station, (resp, err) => {
                    if (err) {
                        console.log(err);
                        cb();
                    }
                    else {
                        newArray.push([Number(resp.LAT), Number(resp.LON)]);
                        lat += Number(resp.LAT);
                        lng += Number(resp.LON);
                        num++;
                        cb();
                    }
                });
            },err => {
                if (err) console.log(err);

                this.setState({...this.state, stations: newArray, lat: lat/num, lng: lng/num});
            })
        } else
            this.props.pollutionAreasActions.fetchPollutionArea(L, this.leafletMap, admin, this.state.currentMap, h);


        this.leafletMap.on('zoom', () => {
            this.setState({currentZoom: this.leafletMap.getZoom()})

        });
        if (admin) {
            this.props.sensorsActions.fetchAdminSensors(this.state.currentMap);

            let bounds = [[35.790146, -10.121665], [44.090168, 4.029806]];
            let mapBounds = L.latLngBounds([[bounds[0][0], bounds[0][1]], [bounds[1][0], bounds[1][1]]]);

            this.leafletMap.setMaxBounds(mapBounds);
        } else {
            this.setState({...this.state, defaultZoom: 12});
            this.leafletMap.setMinZoom(12);
        }

        this.setState({map: this.leafletMap});
    }


    closePolygon() {
        this.props.pollutionAreasActions.closePollutionArea();

        const pollutionArea = {
            location: {
                points: this.props.pollutionAreas.coordinates,
                type: "Polygon"
            },
            name: this.state.newMap,
        };

        this.props.pollutionAreasActions.postPollutionArea(pollutionArea)
    }


    deploySensors(sensorCoords) {

        let location = new SensorLocation(sensorCoords);
        let newSensor = new SensorPoint(null, location, 0);

        this.props.sensorsActions.deploySensors(newSensor, this.state.newMap)

    }

    createSensor(sensorCoords) {

        let location = new SensorLocation(sensorCoords);
        let newSensor = new SensorPoint(null, location, 0);

        this.props.sensorsActions.postSensor(this.state.newMap, newSensor)
    }

    handleClick(e) {
        if (e.type === "click") {
            const coords = [
                e.latlng.lat,
                e.latlng.lng
            ];

            if (!this.props.pollutionAreas.isClosed) {
                if (this.props.pollutionAreas.isCreating) {

                    const polygonPoint = new PolygonPoint(coords);
                    this.props.pollutionAreasActions.addPollutionAreaPoint(polygonPoint)

                }
            } else {
                if (this.props.app.createSensors) {

                    let polygonCoords = [];
                    this.props.pollutionAreas.coordinates[0].map((point) => polygonCoords.push(point));

                    console.log(coords);
                    console.log(polygonCoords);

                    if (insidePolygon(coords, polygonCoords)) {
                        if (this.props.sensors.adminSensors.length === 0) {
                            this.deploySensors(coords)
                        } else {
                            this.createSensor(coords)

                        }
                    }
                } else if (!this.props.slider.isLooping && this.props.heatmaps.list.length) {

                    let polygonCoords = [];
                    this.props.pollutionAreas.coordinates[0].forEach((point) => {
                        polygonCoords.push(point);
                    });
                    if (insidePolygon(coords, polygonCoords)) this.handleAQIPoint(coords);
                    else this.props.analyticsActions.removeAQI()

                }

            }
        }

    }

    handleAQIPoint(coords) {
        if (this.props.heatmaps.display) {
            const timestamp = this.props.heatmaps.display.timestamp;
            this.props.analyticsActions.getAqi(coords, timestamp)
        }
    }

    renderHeatmap() {
        if (this.props.heatmaps.display !== null) {

            // let margin = 5;
            return this.props.heatmaps.list.map((heatmap, index) => {
                // if(this.props.pollutionAreas.layers)

                // if ((this.props.slider.position + margin <= this.props.heatmaps.list.length && index < this.props.slider.position + margin)
                //     || (this.props.slider.position + margin > this.props.heatmaps.list.length && (index >= this.props.slider.position
                //         || index < this.props.slider.position + margin - this.props.heatmaps.list.length)) || this.props.heatmaps.loading) {

                let now = this.props.slider.position === index;

                let now_tran = this.props.slider.position === index + 1 || this.props.slider.position === index - 1 ||
                    (this.props.heatmaps.length === this.props.slider.position + 1 && index === 0) ||
                    (index === this.props.heatmaps.length - 1 && this.props.slider.position === 0);

                return (now && !this.props.heatmaps.loading)
                    ?
                    <HeatMap key={index} tiles={heatmap.tiles} opacity={true}/>
                    :
                    <HeatMap key={index} tiles={heatmap.tiles} opacity={false} opacityTran={now_tran}/>
                // }
            });
        }
    }

    render() {

        const position = [Number(this.state.lat), Number(this.state.lng)];
        const marginBounds = 0.02;
        let bounds = (this.props.pollutionAreas.bbox) ? this.props.pollutionAreas.bbox : [[35.790146, -10.121665], [43.490168, 4.029806]];
        if(this.state.stationMap) {
            let min = [1000, 1000];
            let max = [-1000, -1000];
            this.state.stations.forEach(station => {
                if(station[1] < min[1])
                    min[1] = station[1];
                if(station[1] > max[1])
                    max[1] = station[1];
                if(station[2] < min[2])
                    min[2] = station[2];
                if(station[2] > max[2])
                    max[2] = station[2];
            });
            bounds = [min, max];
        }
        let mapBounds = L.latLngBounds([[bounds[0][0] - marginBounds, bounds[0][1] - marginBounds], [bounds[1][0] + marginBounds, bounds[1][1] + marginBounds]]);

        return (
            <div>

                {!this.state.stationMap && ((this.props.heatmaps.loading || this.props.heatmaps.error) && !this.props.app.isAdmin) &&
                <Loading porcent={this.props.heatmaps.porcent} error={this.props.heatmaps.error}/>}

                <Map
                    onClick={this.handleClick}
                    ref={this.setMap}
                    maxZoom={18}
                    zoomControl={false}
                    center={position}
                    zoom={13}
                    minZoom={this.state.defaultZoom}
                    maxBounds={!this.props.app.isAdmin || this.state.stationMap ? mapBounds : null}
                >

                    <TileLayer
                        attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
                        url='https://tiles.wmflabs.org/bw-mapnik/{z}/{x}/{y}.png '/>

                    {this.state.stationMap && this.state.stations.map((state, key) =>
                        <Marker
                            position={state}
                            draggable={false}
                            key={key}
                        />
                    )}

                    {!this.state.stationMap && this.renderHeatmap()}

                    {!this.props.app.hideSensors &&
                    <DummyCollection
                        sensors={this.props.sensors.list}
                        isAdmin={this.props.app.isAdmin}
                        zoom={this.state.currentZoom}
                        map={this.state.newMap}
                    />}

                    {!this.state.stationMap && !this.props.app.hideSensors && this.props.app.isAdmin &&
                    <Polygon
                        closePollutionArea={this.closePolygon}
                        updatePollutionArea={(pollutionArea) => this.props.pollutionAreasActions.updatePollutionArea(this.state.newMap, pollutionArea, L, this.leafletMap)}
                    />}

                    {!this.state.stationMap && this.props.analytics.aqi &&
                    <AQIMarker
                        {...this.props.analytics.aqi}
                    />}

                </Map>


                {!this.state.stationMap && (!this.props.app.isAdmin ? (
                        <BettAppBar
                            map={this.leafletMap}
                            currentMap={this.state.currentMap}
                        />)
                    :
                    <PolygonPanel
                        map={this.state.newMap}
                    />)}


                {!this.state.stationMap && !this.props.app.isAdmin ? (this.props.app.popUp ?
                    <PopupNotification
                        handleDisableNotification={this.handleDisableNotification}
                        newMap={this.props.app.newMap}/>
                    :
                    <GradientPanel/>)
                    :
                    null}

                <ZoomController
                    handleZoomIn={() => {
                        this.leafletMap.setZoom(this.state.currentZoom + 0.5);
                    }}
                    handleZoomOut={() => {
                        this.leafletMap.setZoom(this.state.currentZoom - 1);
                    }}/>
            </div>

        );
    }
}


const mapStateToProps = (state) => {
    return {
        sensors: state.sensors,
        slider: state.slider,
        pollutionAreas: state.pollutionAreas,
        app: state.app,
        heatmaps: state.heatmaps,
        analytics: state.analytics
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        sensorsActions: bindActionCreators(SensorsActions, dispatch),
        pollutionAreasActions: bindActionCreators(PollutionAreasActions, dispatch),
        appActions: bindActionCreators(AppActions, dispatch),
        analyticsActions: bindActionCreators(AnalyticsActions, dispatch),
    }
};


export default withRouter(connect(mapStateToProps, mapDispatchToProps)(MapBox))



// WEBPACK FOOTER //
// ./src/components/Map/index.js